import Call from '../Call';

const Login = {
    async login(user, password) {
        try {
            const response = await Call('login', 'POST', { user, password });
            if(response.success) {
                localStorage.setItem('token', response.token);
                return true;
            }
        } catch (err) {
            console.error(err);
        }

        return false;
    },

    async isLogged() {
        const token = localStorage.getItem('token');
        if(token) {
            try {
                const response = await Call(`login/${token}`);

                return response.success;
            } catch (err) {
                console.error(err);
            }
        }
        localStorage.removeItem('token');
        return false;
    }
}

export default Login;


// WEBPACK FOOTER //
// ./src/services/API/components/Login.js